import React, { useEffect }  from "react";
import { connect } from "react-redux";
import CardContainer from "components/card";
import { List, Pagination, Card, Image } from "antd";
import { 
	doUploadAnimalPhoto, getAnimalPhotoList
} from "../../../../redux/farmanimal/farmAnimalState";
import DragAndDrop from "components/draganddrop";
import { API_URL } from '../../../../constants';
import { FormatDateValue } from "utils";

const AnimalPhotos = ({uploadFile, getPhotos, recordList, pagination, requesting, success, ...props}) => {
	const { recordId } = props;  

	const dragAndDropUploadHandler = (file, onSuccess, onError) => {
		uploadFile({recordId, file});
	};

	useEffect(() => {
		getPhotos({recordId, paginate: pagination.per_page});
	}, [getPhotos, pagination.per_page]);

	const handlePageChange = (page) => {
		console.log(page);
		getPhotos({recordId, paginate: pagination.per_page});
	};
	
	return (
		<div className="flex w-full">
			<CardContainer extra="w-full p-[20px]">
				<CardContainer extra="w-full">
					<DragAndDrop className="mx-auto w-full" 
						uploadFileHandler={dragAndDropUploadHandler}
						hintMessage="Only image files (JPG, PNG, GIF, etc.) are allowed."
					/>
				</CardContainer>

				<List className="mt-10"
					grid={{ gutter: 16, xs: 2, sm: 3, md: 4, lg: 4 }}
					dataSource={recordList}
					renderItem={(item) => (
					<List.Item>
						<Card className="max-w-[300px]"
						hoverable
						cover={<Image alt={item.attachment.filename} src={`${API_URL}/animal-photo/${item.id}/preview`} preview />}
						>
							<div>
								<label className="font-bold">Uploaded By: </label>
								{item.created_by?.username}
							</div>
							<div>
								<label className="font-bold">Date Uploaded: </label>
								{item.date_uploaded}
							</div>
						</Card>
					</List.Item>
					)}
				/>

				<div style={{ textAlign: "center", marginTop: 20 }}>
					<Pagination
					current={pagination?.current_page}
					total={pagination?.total}
					pageSize={12}
					onChange={handlePageChange}
					/>
				</div>				
			</CardContainer>
		</div>
    );
};

const mapStateToProps = (state) => ({
	recordList: state.farmAnimal.photoList?.items,
	pagination: state.farmAnimal.photoList?.pagination,
  	requesting: state.farmAnimal.photoList?.requesting,
  	error: state.farmAnimal.photoList?.error,	
	success: state.farmAnimal.photoList?.success, 

});

const mapDispatchToProps = (dispatch) => ({
	uploadFile: (data) => dispatch(doUploadAnimalPhoto(data)),
	getPhotos: (data) => dispatch(getAnimalPhotoList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnimalPhotos);